import './pages.css';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import seo from '../seo/pages';

const { pageForPath } = seo;

/**
 * Renders the three marketing pages (/kubernetes-without-aws, /batch-jobs,
 * /gpu-jobs) from src/seo/pages.js - the same heading and paragraphs the
 * prerender writes into the served HTML, so the two cannot drift apart.
 */
export default function SeoArticle() {
  const { pathname } = useLocation();
  const page = pageForPath(pathname);

  // Unknown path (should not happen - these routes are registered explicitly).
  if (!page) return null;

  return (
    <article className="seo-article">
      <h1 className="seo-article-title">{page.h1}</h1>
      {(page.article || []).map((para, i) => (
        <p key={i} className="seo-article-p">{para}</p>
      ))}
      <div className="seo-article-actions">
        <Link to="/pricing" className="seo-article-link">See pricing</Link>
        <Link to="/signup" className="seo-article-cta">Get started free</Link>
      </div>
    </article>
  );
}
